import {useParams} from "react-router-dom"
import useProjectOverview from "../../swrCustomHooks/useProjectOverview"
import useProjectHistory from "../../swrCustomHooks/useProjectHistory"
import LoadingComponent from "../../components/loading-component/LoadingComponent"
import ProjectDashboardHeader from "../../sections/project-dashboard-header/ProjectDashboardHeader"
import ProjectDashboardContent from "../../sections/project-dashboard-content/ProjectDashboardContent"
import ProjectDashboardFooter from "../../sections/project-dashboard-footer/ProjectDashboardFooter"
import RequireIsAdmin from "../../tools/RequireIsAdmin"
import {useSessionContext} from "../../reactContext/contextCustomHooks/useSessionContext"
import {useNwDashboardContext} from "../../reactContext/contextCustomHooks/useNwDashboardContext"

export default function ProjectDashboard() {
    const {sessionContext} = useSessionContext()
    const {nwDashboardContext} = useNwDashboardContext()
    let params = useParams()
    const {projectOverview, isLoadingProjectOverview, isErrorProjectOverview} = useProjectOverview(params.projectID)
    const {projectHistory, isLoadingProjectHistory, isErrorProjectHistory} = useProjectHistory(params.projectID, nwDashboardContext.projectPage)
    if (isErrorProjectOverview || isErrorProjectHistory || isLoadingProjectOverview || isLoadingProjectHistory || projectOverview.message || !projectOverview || !projectHistory) return <LoadingComponent/>
    return (
        <>
        <RequireIsAdmin role={sessionContext.role} redirect={true}>
            <div className="VIEW PROJECT-DASHBOARD">
                <ProjectDashboardHeader projectOverview={projectOverview}/>
                <ProjectDashboardContent projectOverview={projectOverview} projectHistory={projectHistory}/>
                <ProjectDashboardFooter projectID={params.projectID}/>
            </div>
        </RequireIsAdmin>
        </>
    )
}